// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2jOBp","errors":"Errors_errors__1xFLh"};